
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
// 数据看板客户查看关键指标接口
export function getCustomerKeyDataBoard(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/customer/dashboard', data)
}
// 数据看板客户阶段接口
export function getCustomerStageDataBoard(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/customer/statusList', data)
}
// 数据看板成交客户分布情况
export function getTransactCusDistribution(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/customer/levelOrGradeList', data)
}
// 数据看板异动类型分布情况
export function getAlarmTypeDistribution(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/alarm/typeList', data)
}
// 数据看板异动等级分布情况
export function getAlarmLevelDistribution(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/alarm/levelList', data)
}
// 数据看板跟进及时率
export function getFollowUpRate(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/customer/followingUpRateList', data)
}
// 数据看板异动趋势
export function getAlarmTrend(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/alarm/trend', data)
}
// 新激活客户数-区域
export function getRegionNewActivatedCustomerCount(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/customer/activationList', data)
}
// 销售目标完成情况-区域
export function getRegionTargetCompletion(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/revenue/salesAmountList', data)
}
// 查询客户拜访情况
export function getVisitCustomerCompletion(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/customer/visit', data)
}
// 客户营收汇总-区域
export function getRegionCustomerRevenueDataBoard(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/revenue/dashboard', data)
}
// 销售每月业绩目标完成情况-区域
export function getTargetCompletionListByEmployeeNo(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/revenue/targetCompletionListByEmployeeNo', data)
}
// 销售区域每月业绩目标完成情况-区域
export function getTargetCompletionListByDeptId(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/region/revenue/targetCompletionListByDeptId', data)
}
